import React from 'react';
import { motion } from 'framer-motion';
import { Star, MapPin } from 'lucide-react';
export function MoreTestimonials() {
  const reviews = [{
    initials: 'CR',
    name: 'Cecilia R.',
    loc: 'Mendoza',
    plan: 'Combo + Protocolo',
    text: 'El Tomo de Rutinas transformó nuestras mañanas. Mi hijo me pregunta solo qué sigue. Eso antes era imposible.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    loc: 'Buenos Aires',
    plan: 'Combo Completo',
    text: 'Con la Guía de Emergencia bajé un 60% las crisis semanales. El protocolo lo tengo en el celular y lo uso en tiempo real.'
  }, {
    initials: 'SC',
    name: 'Sofía C.',
    loc: 'La Plata',
    plan: 'Combo + Protocolo',
    text: 'El Diario Emocional fue lo que más me agradeció mi hijo. En un mes empezó a decirme cómo se sentía antes de explotar.'
  }, {
    initials: 'PA',
    name: 'Pablo A.',
    loc: 'Neuquén',
    plan: 'Combo Completo',
    text: 'El Tomo de la Escuela me dio las palabras exactas para hablar con la directora. Conseguimos las adaptaciones en una sola reunión.'
  }, {
    initials: 'VL',
    name: 'Valentina L.',
    loc: 'Rosario',
    plan: 'Combo + Protocolo',
    text: 'El Bono de Alimentación llegó justo cuando más lo necesitaba. Cambié el desayuno y las mañanas mejoraron en una semana.'
  }, {
    initials: 'DM',
    name: 'Diego M.',
    loc: 'Córdoba',
    plan: 'Combo Completo',
    text: 'El Mapa de Fortalezas cambió la forma en que mi hijo se ve a sí mismo. Ahora habla de sus superpoderes en vez de sus problemas.'
  }];
  return <section className="py-20 px-4 bg-slate-950" data-id="element-172">
      <div className="max-w-6xl mx-auto" data-id="element-173">
        <div className="text-center mb-12" data-id="element-174">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-175">
            ❤️ MÁS FAMILIAS QUE YA LO TIENEN
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-176">
          {reviews.map((r, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-slate-900 border border-slate-800 rounded-2xl p-6" data-id="element-177">
              <div className="flex justify-between items-start mb-4" data-id="element-178">
                <div className="flex items-center gap-3" data-id="element-179">
                  <div className="w-10 h-10 bg-slate-800 text-slate-300 rounded-full flex items-center justify-center font-bold text-sm" data-id="element-180">
                    {r.initials}
                  </div>
                  <div data-id="element-181">
                    <p className="text-white font-bold text-sm" data-id="element-182">{r.name}</p>
                    <p className="text-slate-500 text-xs flex items-center gap-1" data-id="element-183">
                      <MapPin className="w-3 h-3" data-id="element-184" /> {r.loc}
                    </p>
                  </div>
                </div>
                <div className="flex text-amber-400" data-id="element-185">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-3 h-3 fill-current" data-id="element-186" />)}
                </div>
              </div>
              <p className="text-slate-300 text-sm italic mb-4" data-id="element-187">"{r.text}"</p>
              <div className="inline-block bg-slate-950 border border-slate-800 text-amber-400/80 text-xs px-2 py-1 rounded" data-id="element-188">
                Compró: {r.plan}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}